module.exports = __webpack_public_path__ + "img/13lastpts.3548ac39.png";